.container {
  width: 32rem;

  p {
    font-size: var(--font-size-md);
  }
}
